import React from 'react';
import PropTypes from 'prop-types';
import SvgSymbol from 'common/components/svg-symbol';
import './index.scss';

export default class DropdownMenu extends React.Component {
  static propTypes = {
    arrowStyle: PropTypes.object,
    autoClickSingle: PropTypes.bool,
    children: PropTypes.any,
    className: PropTypes.string,
    isVisible: PropTypes.bool,
    menuPosition: PropTypes.oneOf([
      'down-left',
      'down-right',
      'up-left',
      'up-right',
    ]),
    menuStyle: PropTypes.object,
    rootRef: PropTypes.func,
    svgName: PropTypes.string,
    triggerLabel: PropTypes.string,
    triggerStyle: PropTypes.object,
  };

  static defaultProps = {
    arrowStyle: {},
    autoClickSingle: false,
    className: '',
    isVisible: null,
    menuPosition: 'down-left',
    menuStyle: {},
    svgName: 'dropdown',
    triggerLabel: null,
    triggerStyle: {},
  };

  constructor(props, context) {
    super(props, context);
    this.hide = this.hide.bind(this);
    this.show = this.show.bind(this);

    this.state = {
      menuVisible: false,
    };
  }

  componentDidMount() {
    // Since the menu is positioned absolute, it will lose original
    // Natural width, so assign it inline, unless provided in the menuStyle prop
    const menuWidth = this.props.menuStyle && this.props.menuStyle.width;

    if (!menuWidth && this._menu) {
      const originalMenuWidth = getComputedStyle(this._menu).width;
      this._menu.style.width = originalMenuWidth;
    }
  }

  componentDidUpdate() {
    if (
      this.props.isVisible &&
      this.props.autoClickSingle &&
      this.props.children.length === 1
    ) {
      const first = this._menu.querySelector('a');
      if (first) {
        first.click();
      }
    }
  }

  getMenuClassName() {
    const menuClasses = ['DropdownMenu-menu'];

    if (this.props.isVisible || this.state.menuVisible) {
      menuClasses.push('DropdownMenu-menu--visible');
    }

    menuClasses.push(`DropdownMenu-menu--${this.props.menuPosition}`);

    return menuClasses.join(' ');
  }

  getSvgClassName() {
    const svgClasses = ['DropdownMenu-icon'];

    if (this.state.menuVisible) {
      svgClasses.push('DropdownMenu-icon--visible');
    }

    return svgClasses.join(' ');
  }

  hide() {
    this.setState({menuVisible: false});
    document.removeEventListener('click', this.hide);
  }

  show() {
    if (this.state.menuVisible) {
      this.hide();
      return;
    }

    // Visibility toggle is overridden if prop 'isVisible' is passed
    if (this.props.isVisible !== null) {
      return false;
    }

    this.setState({menuVisible: true});

    setTimeout(() => {
      document.addEventListener('click', this.hide);
    });
  }

  render() {
    const menuClassName = this.getMenuClassName();
    const svgClassName = this.getSvgClassName();

    return (
      <span
        className={`DropdownMenu ${this.props.className}`}
        onClick={this.show}>
        <div className={'DropdownMenu-trigger'}>
          {this.props.triggerLabel ? (
            <span style={this.props.triggerStyle}>
              {this.props.triggerLabel}
            </span>
          ) : null}

          <SvgSymbol
            className={svgClassName}
            name={this.props.svgName}
            style={this.props.arrowStyle}
          />

          <ul
            className={menuClassName}
            ref={(menu) => (this._menu = menu)}
            style={this.props.menuStyle}>
            {this.props.children}
          </ul>
        </div>
      </span>
    );
  }
}
